<template>
  <AdminLayout :title="$t('admin_view_member.view_member_title')" :current="$c.ADMIN.TAB.INFO">
    <div class="section">
      <div class="container" style="width: 90%">                
        <InputSearch type="number" v-model="phone_num" :placeholder='$t("admin_member.mobile_phone")' @click="do_search" ></InputSearch>
        <div style="display:flex; flex-direction:row; align-items: center; justify-content: center;width: 100%; height: 13em; margin-top: 1em; border: solid 1px gray; background: #f0f0f0;" align="center">
          <span v-if="img_src === null" style="font-size: 1.5em;">{{$t('signup_info.business_card_photo')}}</span>
          <b-img v-else :src="img_src" style="width: 100%; height: 100%" @click="showGallery = true"></b-img>
        </div>
        <div style="margin-top:33px; display: flex; justify-content: space-between; flex-wrap: wrap">
          <div class="atom" v-for="item in items">
            <p style="margin-bottom: 0.2em;" class="caption_title">{{item.title}}</p>
            <b-input v-model="item.model" class="info_box info_label" readonly> </b-input>
          </div>
        </div>
      </div>
    </div>
    <Gallery :src="[img_src]"
    :visible.sync="showGallery"
    />
  </AdminLayout>
</template>
<script>
import AdminLayout from './controls/adminlayout'
import InputSearch from './controls/input_search'
import Utils from "../../../../config/utils";
import Gallery from "../../../controls/Gallery";
import moment from "moment";

export default {
  name: "AdminInfo",
  components: {
    AdminLayout,
    InputSearch,
    Gallery
  },
  data() {
    return {
      phone_num:null,
      img_src:null,
      items:{
        f_affiliation:{title:this.$t('admin_view_member.belong'), model:null},
        f_name:{title:this.$t('admin_view_member.name'), model:null},
        f_reg_time:{title:this.$t('admin_view_member.sign_up_date'), model:null},
        f_last_access:{title:this.$t('admin_view_member.last_access_date'), model:null},
        f_sale_count:{title:this.$t('admin_view_member.register_sale_count'), model:null},
        f_community_count:{title:this.$t('admin_view_member.community_post_count'), model:null},
        f_notify_count:{title:this.$t('admin_view_member.noti_regist_count'), model:null},
        f_warned_count:{title:this.$t('admin_view_member.warned_count'), model:null},
        f_point:{title:this.$t('admin_view_member.remaining_point'), model:null},
        f_charge_point:{title:this.$t('admin_view_member.point_charged'), model:null},
      },
      showGallery:false,
    }
  },
  methods:{
    do_search(val){
      Utils.requestGet(
        this.$c.API.User.getUserDetail,
        {
          phone: val.replaceAll('-', ''),
        }
      ).then(result => {
        if (result.code === this.$c.API_RES_CODE.SUCCESS) {
          for(let key in this.items){
            this.items[key].model = result.data[key];
            if(key === "f_reg_time" || key === "f_last_access"){
              this.items[key].model = moment(result.data[key]).format('YYYY/MM/DD');
            }
          }
          this.img_src = result.data['f_business_card'];
        } else {
          for(let key in this.items){
            this.items[key].model = null;
            this.img_src = null;
          }
          Utils.toast(this, result.msg);
        }
      });
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/css/main/admin/Admin.scss';
.atom{
  font-size: 0.9em;
  width: 46%;
  margin-bottom: 1.5em;
}

.caption_title{
  color: black;
  font-size: $fs_13;
  font-family: $korean_gd_17_r;
}
.info_box{
  height: 37px;
  border: solid 1px #f1f1f2;
}
.info_label{
  color: #808080;
  font-size: $fs_18;
  text-align: center;
  font-family: $korean_gd_14_r;
}
</style>



// WEBPACK FOOTER //
// src/components/contents/main/admin/AdminInfo.vue